export const storeLevel = [{
    ID: 1,
    Name: 'HQ'//'Kjede',//Chain    
}, {
    ID: 2,
    Name: 'Klynge',//Cluster
}, {
    ID: 3,
    Name: 'Butikk',//Store
}]

export const userLevel = [{
    ID: 1,
    Name: 'Administrasjon',//Management
}, {
    ID: 2,
    Name: 'Bruker',//User
}]